<template>
  <div class="wrap">
    <div class="middle">
      <img-box class="box" :imgSrc="dynamicImg.backup" :activeImg="dynamicImg.backupAct" title="备份与恢复"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.dataMigration" :activeImg="dynamicImg.dataMigrationAct" title="数据迁移"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.goldOnlineChange" :activeImg="dynamicImg.goldOnlineChangeAct" title="金税盘网上变更"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.taxOnlineChange" :activeImg="dynamicImg.taxOnlineChangeAct" title="报税盘网上变更"></img-box>
    </div>
  </div>
</template>

<script>
import ImgBox from '@/components/ImgBox/Index'
import { dynamicImg } from '@/utils/dynamicImg'
export default {
  components: {
    ImgBox,
  },
  data() {
    return {
      dynamicImg,
    }
  },
  created() {},
}
</script>

<style lang="less" scoped>
.wrap {
  width: 900px;
  height: 600px;
  display: block;
  position: relative;
  // border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
}
.middle {
  flex-basis: 45%;
  height: 70%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 20px;
  .box {
    width: 50%;
  }
}
</style>
